'use client';

import dynamic from 'next/dynamic';
import PageLoader from '@/components/common/PageLoader';

const PricingPageClient = dynamic(
    () => import('@/components/client/landing/PricingPageClient'),
    {
        loading: () => <PageLoader fullPage={true} />,
        ssr: false,
    }
);

export default function PricingDynamicPage() {
    return <PricingPageClient />;
}
